"use strict";
import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    initDesktopSliderLine();
});

const initDesktopSliderLine = () => {
    document.querySelectorAll(".slider-articles-slider-line").forEach((slider) => {
        const wrapper = slider.closest(".slider");

        const scrollbarEl = wrapper.querySelector(".swiper-scrollbar");

        new Swiper(slider, {
            modules: [Scrollbar],
            slidesPerView: 'auto',
            speed: 1000,
            scrollbar: {
                el: scrollbarEl,
                draggable: true,
            }
        });
    });
};
